import { getAdditionalFeesOrderItems } from './getAdditionalFeesOrderItems';
function lineItemToCashierLineItem(lineItem) {
  var _lineItem$productName, _lineItem$productName2, _lineItem$price$amoun, _lineItem$price, _lineItem$quantity;
  return {
    id: lineItem.id,
    name: (_lineItem$productName = (_lineItem$productName2 = lineItem.productName) == null ? void 0 : _lineItem$productName2.translated) != null ? _lineItem$productName : '',
    price: (_lineItem$price$amoun = (_lineItem$price = lineItem.price) == null ? void 0 : _lineItem$price.amount) != null ? _lineItem$price$amoun : '0',
    quantity: (_lineItem$quantity = lineItem.quantity) != null ? _lineItem$quantity : 0
  };
}
export function getOrderItemsFromCheckout(checkout) {
  var _checkout$lineItems$m, _checkout$lineItems;
  const orderItems = (_checkout$lineItems$m = (_checkout$lineItems = checkout.lineItems) == null ? void 0 : _checkout$lineItems.map(lineItemToCashierLineItem)) != null ? _checkout$lineItems$m : [];
  const additionalFeesAsOrderItems = getAdditionalFeesOrderItems(checkout.additionalFees);
  return [...orderItems, ...additionalFeesAsOrderItems];
}
//# sourceMappingURL=getOrderItemsFromCheckout.js.map